<template>
  <footer class="footer-wrapper">
    <div class="footer">
      <div class="footer_main">
        <div class="footer_main-img">
          <img src="@/assets/logo.jpg">
        </div>
        <div class="footer_main_item">
          <p class="footer_main_item-title">Email</p>
          <a target="_blank" href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=info@rgeahosa.org" class="footer_main_item-p">info@rgeahosa.org </a>
          <p class="footer_main_item-title">Address</p>
          <p class="footer_main_item-p">1 Club Road, Golden Gate, Regimanuel Gray Estate</p>
          <p class="footer_main_item-p"> East Airport, Accra</p>
        </div>
        <div class="footer_main_item">
          <p class="footer_main_item-title">Phone</p>
          <p class="footer_main_item-p">+233 050 145 3030</p>
        </div>
        <div class="footer_main_item">
          <ul>
            <li class="footer_main_item-link" @click="upScroll()"><router-link to="/">Home</router-link></li>
            <li class="footer_main_item-link" @click="upScroll()" v-if="!isAuthorized"><router-link to="/login">Member Access</router-link></li>
<!--            <li class="footer_main_item-link" @click="upScroll()"><router-link to="/about-us" v-if="!isAuthorized">About Us</router-link></li>-->
            <li class="footer_main_item-link" @click="upScroll()"><router-link to="/library" v-if="isAuthorized">Documents</router-link></li>
            <li class="footer_main_item-link" @click="upScroll()"><router-link to="/events" v-if="isAuthorized">Events</router-link></li>
            <li class="footer_main_item-link" @click="upScroll()"><router-link to="/gallery" v-if="isAuthorized">Gallery</router-link></li>
            <li class="footer_main_item-link" @click="upScroll()"><router-link to="/council" v-if="isAuthorized">Council Members</router-link></li>
            <li class="footer_main_item-link" @click="upScroll()"><router-link to="/contacts">Contact Us</router-link></li>
          </ul>
        </div>
        <button class="footer_main-button" @click="upScroll()">
          <img src="@/assets/png/onTop.png">
        </button>
      </div>
    </div>
    <div class="footer_down">
        <p class="footer_down-title">Home Rgea Hosa 2019</p>
      </div>
  </footer>

</template>

<script>
export default {
  data() {
    return {
      isAuthorized: false,
    }
  },
  mounted(){
    if(localStorage.getItem('token') != null){
      this.isAuthorized = true;
    }
  },
  methods: {
    upScroll() {
        let top = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
        if(top > 0) {
            window.scrollBy(0,-100);
            setTimeout(()=>{
              this.upScroll()
            },20);
          }
    },
  }
}
</script>

<style lang="scss" scoped>
.footer {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  &-wrapper {
    width: 100%;
    background-color: #ffffff;
  }
  &_main {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    @media screen and (max-width: 850px) {
      justify-content: space-between;
      margin-bottom: 24px;
    }
    &-img {
      width:25%;
      display: flex;
      justify-content: center;
      align-items: center;
      img { width:100%;}
        @media screen and (max-width: 480px) {
          margin-right: 15px;
        }
      }
    &-button {
      border:none;
      outline: none;
      cursor: pointer;
      background-color:transparent;
      position: absolute;
      bottom:10px;
      left: 0;
      @media screen and (max-width: 850px) {
        bottom:-45px;
      }
    }
    &_item {
      display: flex;
      flex-direction: column;
      @media screen and (max-width: 650px) {
        width:23%;
      }
      @media screen and (max-width: 480px) {
        width: auto;
      }
      ul {
        list-style: none;
        padding: 0;
        @media screen and (max-width: 480px) {
          display: none;
        }
      }
      &-title {
        color: #4a4a4a;
        font-family: "Gotham Pro";
        font-size: 12px;
        font-weight: bold;
        padding-top:28px;
        padding-bottom: 6px;
        letter-spacing: 0.6px;
        margin:0;
      }
      &-p {
        color: #9b9b9b;
        font-family: "Open Sans";
        font-size: 12px;
        font-weight: 400;
        line-height: 2.4;
        letter-spacing: 0.3px;
        margin:0;
        text-decoration: none;
        @media screen and (max-width: 440px) {
          font-size: 9px;
        }
        @media screen and (max-width: 350px) {
          font-size: 7px;
        }
      }
      &-link {
        a {
          text-decoration:none;
          color: #3a3a44;
          font-family: "Open Sans";
          font-size: 16px;
          font-weight: 400;
          line-height: 36px;
          letter-spacing: 0.4px;
          &:hover {
            color:#1a924a !important;
          }
        }
      }
    }
  }
  &_down {
    border-top: 1px solid #e4e4e4;
    &-title {
      color: #959695;
      font-family: "Gotham Pro";
      font-size: 12px;
      font-weight: 400;
      line-height: 36px;
      letter-spacing: 0.6px;
      text-align: center;
    }
  }
}
</style>
